const FooterSection = () => {
    return (
        <section className='footer-section'>
            <p>If you have any questions please reach out to us!<br />cofounder@junglo.xyz</p>
        </section>
    )
}

export default FooterSection